<div class="checkout-container">
  <ng-container *ngIf="isInitialised; then initialised; else loading"></ng-container>
  <ng-template #initialised>
    <ng-container *ngIf="checkoutLocation">
      <div class="checkoutLocation-detail-impressum">
        <div class="checkoutLocation-detail-content-wrapper">
          <div class="list-header_icon">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
            </div>
          </div>
          <ul>
            <h2 *ngIf="checkoutLocation?.label">{{checkoutLocation.label}}</h2>
            <li *ngIf="checkoutLocation?.address">
              <span>{{checkoutLocation.address}}</span>
            </li>
            <li *ngIf="checkoutLocation?.stnr">
              <span langkey="phInHouseLocalBasket_ImpressumDialog_stnr"></span>
              <span class="checkoutLocation-detail-text">{{checkoutLocation.stnr}}</span>
            </li>
            <li *ngIf="checkoutLocation?.ustid">
              <span langkey="phInHouseLocalBasket_ImpressumDialog_ustid"></span>
              <span class="checkoutLocation-detail-text">{{checkoutLocation.ustid}}</span>
            </li>
            <li *ngIf="impressumModelData?.impressumHtml && impressumModelData?.impressumHtml">
              <div (click)="openLocationImpressumDialog()">
                <span class="privacyLink" langkey="phInHouseLocalBasket_ImpressumDialog"></span>
              </div>
            </li>
          </ul>
          <ul>
            <li *ngIf="checkoutLocation?.commercial_register">
              <span langkey="phInHouseLocalBasket_ImpressumDialog_commercial_register"></span>
              <span class="checkoutLocation-detail-text">{{checkoutLocation.commercial_register}}</span>
            </li>
            <li *ngIf="checkoutLocation?.representative">
              <span langkey="phInHouseLocalBasket_ImpressumDialog_representative"></span>
              <span class="checkoutLocation-detail-text">{{checkoutLocation.representative}}</span>
            </li>
            <li *ngIf="checkoutLocation?.local_court">
              <span langkey="phInHouseLocalBasket_ImpressumDialog_local_court"></span>
              <span class="checkoutLocation-detail-text">{{checkoutLocation.local_court}}</span>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
    <div class="payment-form" [ngClass]="showWebDropIn ? 'hidden' : ''">
      <div class="col">
        <ng-container *ngIf="canUseWebvoucher">
          <div class="payment-webvoucher-container">
            <ng-container *ngIf="hasWebvoucher; then webvouchercard; else inputWebvoucher"></ng-container>
            <ng-template #webvouchercard>
              <ng-container *ngIf="show_hs_webvoucher">
                <div a11y_Checkbox class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple" [checked]="useWebvoucherBalance"
                    (change)="onUseWebvoucherChange($event)"></mat-checkbox>
                </div>
              </ng-container>
              <div class="payment-webvoucher-content">
                <h4 langkey="phPayment_Webvoucher_Usage"></h4>
                <div class="payment-webvoucher-info" [innerHtml]="webvoucherInfoText"></div>
              </div>
            </ng-template>
            <ng-template #inputWebvoucher>
              <div class="payment-webvoucher-input-container">
                <div class="ya-input-container">
                  <div class="ya-input-wrapper">
                    <div class="inputs-text">
                      <input a11y_Input #codeInput type="text" class="ya-input-text" (keydown.enter)="codeInput.blur()"
                        [placeholder]="webvoucherInputPlaceholder" [formControl]="voucherFC" maxlength="18" />
                    </div>
                    <div [class.ya-input-invalid]="voucherFC.invalid &&(voucherFC.dirty || voucherFC.touched)"
                      class="ya-error-validaton-container">
                      <ng-container *ngIf="voucherFC.errors">
                        <div class="ya-error-validation" *ngIf="voucherFC.errors.pattern">
                          <div class="error-validation-icon">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
                          </div>
                          <div class="error-validation-text ya-caption">
                            <span langkey="phPayment_Validate_WebvoucherPattern"></span>
                          </div>
                        </div>
                        <div class="ya-error-validation" *ngIf="voucherFC.errors.voucherInvalid">
                          <div class="error-validation-icon">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
                          </div>
                          <div class="error-validation-text ya-caption">
                            <span langkey="phPayment_Validate_WebvoucherExists"></span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <div class="payment-total-container">
          <div class="payment-info">
            <h3 langkey="phGlobal_Sum"></h3>
            <h3>{{ priceFormatter(sum_base) }}</h3>
          </div>
          <ng-container *ngIf="sum_discount != 0">
            <div class="payment-info">
              <h3 langkey="phGlobal_Discount"></h3>
              <h3>{{ priceFormatter(sum_discount) }}</h3>
            </div>
          </ng-container>
          <ng-container *ngIf="sum_deposit != 0">
            <div class="payment-info">
              <h3 langkey="phGlobal_Deposit"></h3>
              <h3>{{ priceFormatter(sum_deposit) }}</h3>
            </div>
          </ng-container>
          <ng-container *ngIf="sum_delivery_fee != 0">
            <div class="payment-info">
              <h3 langkey="phGlobal_DeliveryFee"></h3>
              <h3>{{ priceFormatter(sum_delivery_fee) }}</h3>
            </div>
          </ng-container>
          <ng-container *ngIf="sum_tip != 0">
            <div class="payment-info">
              <h3 langkey="phWebshop_Shippingcart_tip"></h3>
              <h3>{{ priceFormatter(sum_tip) }}</h3>
            </div>
          </ng-container>
          <mat-divider></mat-divider>
          <div class="payment-info">
            <h4 langkey="phGlobal_Total"></h4>
            <h4>{{ priceFormatter(sum_total) }}</h4>
          </div>
          <ng-container *ngIf="vatStats.length == 1; then singleVat; else multiVat"></ng-container>
          <ng-template #singleVat>
            <ng-container *ngIf="vatStats[0].vat != 0">
              <div class="payment-info payment-info--vat">
                <span>MwSt. {{ vatStats[0].percent }}% (
                  {{ priceFormatter(vatStats[0].assessedAmount) }} )</span>
                <span>{{ priceFormatter(vatStats[0].vat) }}</span>
              </div>
            </ng-container>
          </ng-template>
          <ng-template #multiVat>
            <ng-container *ngFor="let vat of vatStats; let i = index">
              <ng-container *ngIf="vat.vat != 0">
                <div class="payment-info payment-info--vat">
                  <span>MwSt. {{ vatEnumeration[i] }} {{ vat.percent }}% (
                    {{ priceFormatter(vat.assessedAmount) }} )</span>
                  <span>{{ priceFormatter(vat.vat) }}</span>
                </div>
              </ng-container>
            </ng-container>
          </ng-template>
          <ng-container *ngIf="sum_webvoucher != 0">
            <mat-divider></mat-divider>
            <div class="payment-info">
              <h3 langkey="phPayment_Webvoucher"></h3>
              <h3>-{{ priceFormatter(sum_webvoucher) }}</h3>
            </div>
            <div class="payment-info">
              <h4 langkey="phPayment_FinalPrice"></h4>
              <h4>{{ priceFormatter(sum_total - sum_webvoucher) }}</h4>
            </div>
          </ng-container>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="col second">
        <ng-container *ngIf="show_paymentmethods">
          <h4 langkey="phPayment_ChooseYourPaymentMethod"></h4>

          <div class="payment-options-container" *ngIf="
              useSplitPaymentMethods;
              then paymentOptionsSplitted;
              else paymentOptions
            "></div>

          <ng-template #paymentOptions>
            <ng-container *ngIf="show_hs_pay_at_waiter">
              <div class="payment-options-container__option">
                <div class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple"
                    [checked]="selectedPaymentMethod == CheckboxPaymentMethod.PayAtWaiter"
                    (change)="selectPaymentMethod($event, CheckboxPaymentMethod.PayAtWaiter)">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text" langkey="phPayment_PayAtWaiter"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_hs_cash">
              <div class="payment-options-container__option">
                <div a11y_Checkbox class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple" [checked]="
                      selectedPaymentMethod == CheckboxPaymentMethod.Cash
                    " (change)="
                      selectPaymentMethod($event, CheckboxPaymentMethod.Cash)
                    ">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text" [langkey]="
                    service == WebShopMode.TakeAway || service == WebShopMode.PickupGroup
                      ? 'phPayment_PayOnCollection'
                      : 'phPayment_CashDelivery'
                  "></div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_hs_cashless">
              <div class="payment-options-container__option">
                <div a11y_Checkbox class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple" [checked]="
                      selectedPaymentMethod == CheckboxPaymentMethod.Cashless
                    " (change)="
                      selectPaymentMethod(
                        $event,
                        CheckboxPaymentMethod.Cashless
                      )
                    ">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text" [langkey]="
                    service == WebShopMode.TakeAway || service == WebShopMode.PickupGroup
                      ? 'phPayment_PayOnCollection'
                      : 'phPayment_CashlessDelivery'
                  "></div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_hs_paypal">
              <div class="payment-options-container__option">
                <div a11y_Checkbox class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple" [checked]="
                      selectedPaymentMethod == CheckboxPaymentMethod.PayPal
                    " (change)="
                      selectPaymentMethod($event, CheckboxPaymentMethod.PayPal)
                    ">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text" langkey="phPayment_PayPal"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="shouldShowAccountPaymentRow">
              <div class="payment-options-container__option"
                [class.payment-options-container__option--disabled]="isAccountPaymentRowDisabled">
                <div a11y_Checkbox class="input-checkbox-container" [attr.aria-disabled]="isAccountPaymentRowDisabled">
                  <mat-checkbox class="custom-ripple"
                    [checked]="isAccountPaymentRowChecked"
                    [disabled]="isAccountPaymentRowDisabled"
                    (change)="selectPaymentMethod($event, CheckboxPaymentMethod.Accounting)">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text" langkey="phAccountPayment_SectionLabel"></div>
              </div>
              <ng-container *ngTemplateOutlet="accountPaymentRowAddon"></ng-container>
            </ng-container>
            <ng-container *ngIf="show_adyen">
              <div class="payment-options-container__option">
                <div a11y_Checkbox class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple" [checked]="
                      selectedPaymentMethod == CheckboxPaymentMethod.Adyen
                    " (change)="
                      selectPaymentMethod($event, CheckboxPaymentMethod.Adyen)
                    ">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text">
                  <div class="text" langkey="phPayment_MorePaymentMethods"></div>
                  <div class="adyenicons">
                    <ng-container *ngFor="let icon of adyenPaymentIcons">
                      <span class="screen-reader-only" [langkey]="'phPayment_MethodName_' + icon"></span>
                      <div class="adyen-icon" aria-hidden="true" [inlineSVG]="'adyenpmicons/' + icon + '.svg'"></div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_wallee">
              <div class="payment-options-container__option">
                <div a11y_Checkbox class="input-checkbox-container">
                  <mat-checkbox class="custom-ripple" [checked]="
                      selectedPaymentMethod == CheckboxPaymentMethod.Wallee
                    " (change)="
                      selectPaymentMethod($event, CheckboxPaymentMethod.Wallee)
                    ">
                  </mat-checkbox>
                </div>
                <div class="payment-options-container__Text">
                  <div class="text" langkey="phPayment_MorePaymentMethods"></div>
                  <div class="walleeIcons">
                    <ng-container *ngFor="let payment of walleePaymentMethods">
                      <div aria-hidden="true">
                        <img [src]="payment.imageUrl" />
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>

          <!-- Splitted payment options -->
          <ng-template #paymentOptionsSplitted>
            <ng-container *ngIf="show_hs_pay_at_waiter">
              <div class="payment-options-singleRow-container">
                <div class="input-checkbox-container-splitPayment">
                  <mat-checkbox class="custom-ripple" [disableRipple]="true"
                    [checked]="selectedSinglePaymentMethod === stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.PayAtWaiter)"
                    (change)="selectSinglePaymentMethod($event, stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.PayAtWaiter))">
                    <div class="payment-options-container__Text" langkey="phPayment_PayAtWaiter"></div>
                  </mat-checkbox>
                </div>

                <div class="icons">
                  <span class="screen-reader-only" langkey="phPayment_PayAtWaiter"></span>
                  <div class="icon" aria-hidden="true" [inlineSVG]="getPathToCheckoutSvg('money')"></div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_hs_cash">
              <div class="payment-options-singleRow-container">
                <div a11y_Checkbox class="input-checkbox-container-splitPayment">
                  <mat-checkbox class="custom-ripple" [disableRipple]="true"
                    [checked]=" selectedSinglePaymentMethod === stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Cash)"
                    (change)="selectSinglePaymentMethod($event, stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Cash))">
                    <div class="payment-options-container__Text"
                      [langkey]="service == WebShopMode.TakeAway || service == WebShopMode.PickupGroup ? 'phPayment_PayOnCollection' : 'phPayment_CashDelivery'">
                    </div>
                  </mat-checkbox>
                </div>

                <div class="icons">
                  <span class="screen-reader-only"
                    [langkey]="service == WebShopMode.TakeAway || service == WebShopMode.PickupGroup ? 'phPayment_PayOnCollection' : 'phPayment_CashDelivery'">
                  </span>

                  <div class="icon" aria-hidden="true" [inlineSVG]="getPathToCheckoutSvg('money')">
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_hs_cashless">
              <div class="payment-options-singleRow-container">
                <div a11y_Checkbox class="input-checkbox-container-splitPayment">
                  <mat-checkbox class="custom-ripple" [disableRipple]="true"
                    [checked]="selectedSinglePaymentMethod === stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Cashless)"
                    (change)="selectSinglePaymentMethod($event, stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Cashless))">
                    <div class="payment-options-container__Text"
                      [langkey]="service == WebShopMode.TakeAway || service == WebShopMode.PickupGroup ? 'phPayment_CashlessTakeaway' : 'phPayment_CashlessDelivery'">
                    </div>
                  </mat-checkbox>
                </div>

                <div class="icons">
                  <span class="screen-reader-only"
                    [langkey]="service == WebShopMode.TakeAway || service == WebShopMode.PickupGroup ? 'phPayment_CashlessTakeaway' : 'phPayment_CashlessDelivery'">
                  </span>

                  <div class="icon" aria-hidden="true" [inlineSVG]="getPathToCheckoutSvg('card')">
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="show_adyen">
              <ng-container *ngFor="let paymentMethod of paymentMethodsForSplittedView">
                <div class="payment-options-singleRow-container">
                  <div a11y_Checkbox class="input-checkbox-container-splitPayment">
                    <mat-checkbox class="custom-ripple" [disableRipple]="true"
                      [checked]="selectedSinglePaymentMethod === paymentMethod.type"
                      (change)="selectSinglePaymentMethod($event, paymentMethod.type)">
                      {{ paymentMethod.name }}
                    </mat-checkbox>
                  </div>

                  <div class="icons">
                    <ng-container *ngFor="let icon of paymentMethod.icons">
                      <span class="screen-reader-only" [langkey]="'phPayment_MethodName_' + icon"></span>
                      <div class="icon" aria-hidden="true" [inlineSVG]="getPathToAdyenSvg(icon)">
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="show_hs_paypal">
              <div class="payment-options-singleRow-container">
                <div a11y_Checkbox class="input-checkbox-container-splitPayment">
                  <mat-checkbox class="custom-ripple" [disableRipple]="true"
                    [checked]="selectedSinglePaymentMethod === stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.PayPal)"
                    (change)="selectSinglePaymentMethod($event, stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.PayPal))">
                    <div class="payment-options-container__Text" langkey="phPayment_PayPal"></div>
                  </mat-checkbox>
                </div>

                <div class="icons">
                  <span class="screen-reader-only" [langkey]="'phPayment_MethodName_paypal'"></span>
                  <div class="icon" aria-hidden="true" [inlineSVG]="getPathToAdyenSvg('paypal')"></div>
                </div>
              </div>
            </ng-container>
            <!--Account payment -->
            <ng-container *ngIf="shouldShowAccountPaymentRow">
              <div class="payment-options-singleRow-container"
                [class.payment-options-singleRow-container--disabled]="isAccountPaymentRowDisabled">
                <div a11y_Checkbox class="input-checkbox-container-splitPayment" [attr.aria-disabled]="isAccountPaymentRowDisabled">
                  <mat-checkbox class="custom-ripple" [disableRipple]="true"
                    [checked]="isAccountPaymentSingleRowChecked"
                    [disabled]="isAccountPaymentRowDisabled"
                    (change)="selectSinglePaymentMethod($event, stringifyCheckboxPaymentMethod(CheckboxPaymentMethod.Accounting))">
                    <div class="payment-options-container__Text" langkey="phAccountPayment_SectionLabel"></div>
                  </mat-checkbox>
                </div>
                <div class="icons">
                  <span class="screen-reader-only" langkey="phAccountPayment_SectionLabel"></span>
                  <div class="icon" aria-hidden="true" [inlineSVG]="getPathToCheckoutSvg('accounting')"></div>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="accountPaymentRowAddon"></ng-container>
            </ng-container>
          </ng-template>
          <!--Account payment templates-->
          <ng-template #accountPaymentRowAddon>
            <ng-container [ngSwitch]="accountPaymentRowState">
              <ng-container *ngSwitchCase="AccountPaymentRowState.Selectable">
                <ng-container *ngTemplateOutlet="accountPaymentAvailableHint"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="AccountPaymentRowState.LimitBlocked">
                <ng-container *ngTemplateOutlet="accountPaymentLimitStatus"></ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
          <ng-template #accountPaymentAvailableHint>
            <div class="account-payment-checkout__hint-text" *ngIf="showAvailableCreditHint">
              <span
                class="account-payment-checkout__amount">{{priceFormatter(accountPaymentCreditValues.available)}}</span>
              <span>{{accountPaymentCustomer.availableLabel}}</span>
            </div>
          </ng-template>
          <ng-template #accountPaymentLimitStatus>
            <ng-container *ngIf="accountPaymentCustomer && accountPaymentCreditValues">
              <!--Blocked / limit reached-->
              <div class="account-payment-checkout__limit-reached" *ngIf="accountPaymentLimitResult.isLimitReached">
                <div class="account-payment-checkout__warning-icon inline-icon"
                  inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
                <div class="account-payment-checkout__limit-reached-text">
                  <span>{{accountPaymentCustomer.usedBalanceLabel}}</span>
                  <span
                    class="account-payment-checkout__amount account-payment-checkout__amount--highlight">{{priceFormatter(accountPaymentCreditValues.usedBalance)}}</span>
                  <span>{{accountPaymentCustomer.limitReachedPaymentBlockedHint}}</span>
                </div>
              </div>
              <!--Blocked/ over limit-->
              <div class="account-payment-checkout__limit-reached" *ngIf="accountPaymentLimitResult.isOverLimit">
                <div class="account-payment-checkout__warning-icon inline-icon"
                  inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
                <div class="account-payment-checkout__limit-reached-text">
                  <span>{{accountPaymentCustomer.overLimitHint}}</span>
                  <span
                    class="account-payment-checkout__amount">({{priceFormatter(accountPaymentCreditValues.available)}})</span>
                  <span
                    class="account-payment-checkout__amount account-payment-checkout__amount--highlight">{{priceFormatter(accountPaymentLimitResult.exceedAmount)}}</span>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="!in_house && isBasketComment">
          <div class="ya-input-container comment-container">
            <textarea class="ya-input-textarea comment" [placeholder]="commentPlaceholder" maxlength="120"
              [(ngModel)]="order.comment" (blur)="setOrderComment()"></textarea>
          </div>
        </ng-container>

        <div class="payment-options-container__option term-container">
          <div a11y_Checkbox class="input-checkbox-container">
            <mat-checkbox class="custom-ripple" [checked]="hasAcceptedAGB"
              (change)="hasAcceptedAGB = $event.checked"></mat-checkbox>
          </div>
          <div #privacyContent (click)="onShowTermsClick($event)" class="payment-options-container__Text"
            [innerHtml]="AGB_innerhtml"></div>
        </div>
        <!-- Newsletter Checkbox -->
        <ya-newsletter-checkbox #newsletterCheckbox></ya-newsletter-checkbox>

        <div class="ya-webshop-button-container continue-button">
          <button a11y_Button mat-flat-button [disabled]="!isAllowedToPay" (click)="onConfirmOrderData()">
            <ng-container *ngIf="!in_house">
              <span langkey="phPayment_OrderNowWithCosts"></span>
            </ng-container>
            <ng-container *ngIf="in_house">
              <span langkey="phPayment_PayNow"></span>
            </ng-container>
          </button>
        </div>
      </div>
    </div>

    <div class="payment-dropin" [ngClass]="showWebDropIn ? '' : 'hidden'">
      <div class="InputWrapper">
        <div class="hypersoftpay-logo" inlineSVG="shop-icons.svg#ya-hypersoftpay-logo"></div>
        <div id="dropin-container"></div>
      </div>
    </div>

  </ng-template>
  <ng-template #loading> </ng-template>
</div>